import { SnowplowService } from 'wanderu-service-analytics';

function buttonClicked({ navType, label }) {
    SnowplowService.fireStructuredEvent({
        category: 'navigation',
        action: 'click',
        label,
        property: {
            nav_type: navType,
        },
    });
}

export default {
    buttonClicked,
};
